import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function Home() {
  return (
    <div className="home d-flex flex-column min-vh-100 bg-light">
      {/* Hero Section */}
      <section className="home-hero text-center text-white bg-dark py-5">
        <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="container"
        >
          <h2 className="display-4 fw-bold">Наши лучшие предложения</h2>
          <p className="lead">Ознакомьтесь с новинками и горячими предложениями.</p>
          <Link to="/products" className="btn btn-light mt-3">
            Перейти к продуктам
          </Link>
        </motion.div>
      </section>

      {/* Features Section */}
      <section className="home-features py-5 text-center flex-grow-1">
        <h2 className="fw-bold mb-4">Почему выбирают нас?</h2>
        <div className="container">
          <div className="row justify-content-center">
            {[
              { title: "Качество", text: "Гарантия высокого качества каждого продукта." },
              { title: "Надежность", text: "Гарантия возврата и профессиональный сервис." },
              { title: "Доступные цены", text: "Лучшее соотношение цены и качества." },
            ].map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
                viewport={{ once: true }}
                className="col-md-4 mb-3"
              >
                <div className="card shadow-sm p-4">
                  <h3 className="text-primary">{feature.title}</h3>
                  <p>{feature.text}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="home-footer bg-dark text-white text-center py-3 mt-auto">
        <p>&copy; 2025 Outwest. Все права защищены.</p>
      </footer>
    </div>
  );
}
